var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-10 col-sm-10 col-md-10 col-lg-10 mt-1"},[_c('a-input',{attrs:{"placeholder":_vm.generatedPlaceholder},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }